/**
 * Removes keys from an object based on their values.
 *
 * @param obj - The object from which keys will be removed.
 * @param predicate - A function that returns true for values to be removed.
 * @returns The modified object with the specified keys removed.
 */
export const removeKeysByValue = <T>(obj: Record<string, T>, predicate: (value: T) => boolean): Record<string, T> => {
    if (!obj) return {};

    return Object.keys(obj).reduce(
        (acc, key) => {
            if (!predicate(obj[key])) {
                Object.assign(acc, { [key]: obj[key] });
            }
            return acc;
        },
        {} as Record<string, T>,
    );
};
